import React from "react"
import { graphql } from "gatsby"

import Header from "../components/header"
import Footer from "../components/footer"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Reviews from "../components/reviews"
import SkipSizes from "../components/skipSizes"
import Form from "../components/form"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"

const LocationPage = ({ data: { location, heroImage }}) => {
  return (
  <>
    <SEO 
      title={location.name}
    />
    
    {/* Header */}
    <Header
      location={location.name}
      phoneNumber={location.phoneNumber}
    />

    {/* Hero */}
    <Hero 
      title={`Low Cost <strong>Skip Hire</strong><br/>in <strong>${location.name}.</strong>`}
      heroImage={heroImage}
    />

    {/* Skip Sizes */}
    <section id="skip-sizes">
      <SkipSizes
        phoneNumber={location.phoneNumber}
      />
    </section>

    {/* Reviews Widget */}
    {location.associatedClient.reviewsStoreId && (
      <section id="reviews">
        <div className="container mb-12 md:mb-16 lg:mb-24">
          <div className="flex flex-wrap">
            <Reviews storeId={location.associatedClient.reviewsStoreId} />
          </div>
        </div>
      </section>
    )}

    {/* In Page USP's */}
    <div className="w-full mb-12 md:mb-24">
      <div class="flex flex-wrap">
        <div class="w-full md:w-1/2 py-12 px-8 md:py-16 lg:py-24 bg-secondary-dark">
          <div className="max-w-2xl md:ml-auto md:pr-8 lg:pr-16">
            <h2 className="text-2xl xl:text-3xl text-white">Waste Management</h2>
            <ul>
              <li className="text-base sm:text-lg xl:text-xl mb-2 text-secondary-light"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Domestic, commercial and industrial waste</li>
              <li className="text-base sm:text-lg xl:text-xl mb-2 text-secondary-light"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Hazardous waste handling</li>
              <li className="text-base sm:text-lg xl:text-xl mb-2 text-secondary-light"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Landfill diversion</li>
            </ul>
          </div>
        </div>
        <div class="w-full md:w-1/2 py-12 px-8 md:py-16 lg:py-24 bg-secondary">
          <div className="max-w-2xl mr-auto md:pl-8 lg:pl-16">
            <h2 className="text-2xl xl:text-3xl text-white">Recycling</h2>
            <ul>
              <li className="text-base sm:text-lg xl:text-xl mb-2 text-secondary-light"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Sustainable and eco-friendly</li>
              <li className="text-base sm:text-lg xl:text-xl mb-2 text-secondary-light"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> Domestic and commercial</li>
              <li className="text-base sm:text-lg xl:text-xl mb-2 text-secondary-light"><FontAwesomeIcon className="text-primary text-lg mr-2" icon="check" /> 100% of waste recycled</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    {/* Content */}
    <section className="mb-12 md:mb-24" id="content">
      <div className="container">
        <div className="content max-w-3xl mx-auto">
          <h1 className="text-black">Skip Hire in {location.name}</h1>
          <p className="text-lg">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec vel diam erat. Nulla volutpat elementum velit at suscipit.</p>

          <p>Aenean tristique sed sem quis elementum. Vestibulum convallis dolor id diam vehicula, a ultricies dui accumsan. Donec ut metus iaculis, mollis ex ac, sodales felis. Morbi in condimentum massa, vitae efficitur massa.</p>
          
          <p>Cras vestibulum eu leo eget pharetra. In hac habitasse platea dictumst. Ut et nulla tincidunt, hendrerit ex sed.</p>
        </div>
      </div>
    </section>

    {/* Form */}
    <div className="bg-secondary-dark py-12 md:py-24 lg:py-32" id="quote">
      <div className="container">
        <div className="mb-10 md:mb-16">
          <span className="text-center block text-white text-xl md:text-2xl lg:text-3xl">Get a <strong>FREE Quick Quote</strong></span>
          <span className="text-center text-secondary-light block text-lg">Fill in your details below and our team will be in touch.</span>
        </div>
        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap items-center md:-mx-6">
            <div className="w-full md:w-1/2 px-8 mb-8 md:mb-0 md:px-0 md:px-6">
              <Form name={`Quote Form`} />
            </div>
            <div className="w-full md:w-1/2 px-8 md:px-6">
              <ul className="text-white">
                <li className="text-lg lg:text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-1" icon="check" /> All permits organised</li>
                <li className="text-lg lg:text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-1" icon="check" /> Same or next day delivery</li>
                <li className="text-lg lg:text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-1" icon="check" /> Best prices guaranteed</li>
                <li className="text-lg lg:text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-1" icon="check" /> Sustainable &amp; eco-friendly</li>
                <li className="text-lg lg:text-xl mb-2"><FontAwesomeIcon className="text-primary text-lg mr-1" icon="check" /> Domestic &amp; commercial</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* Footer CTA */}
    <div className="bg-secondary py-16 md:py-20 lg:py-24">
      <div className="container">
        <span className="text-xl md:text-2xl xl:text-3xl text-white font-bold block mb-2 leading-snug">Operating in {location.name} and the surrounding area.</span>
        <span className="text-lg md:text-xl xl:text-2xl text-secondary-light">For more information call us today on 0800 000 0000.</span>
      </div>
    </div>

    {/* Footer */}
    <Footer
      companyName={location.associatedClient.name}
    />
  </>
  )
}

export default LocationPage

export const query = graphql`
  query LocationQuery($slug: String!) {
    location: datoCmsLocation(slug: { eq: $slug }) {
      name
      phoneNumber
      mailAddress
      associatedClient {
        name
        reviewsStoreId
      }
    }
    heroImage: file(relativePath: { eq: "hero.jpg" }) {
      childImageSharp {
        fluid(quality: 90, maxWidth: 1200) {
          ...GatsbyImageSharpFluid_withWebp
        }
      }
    }
  }
`